import { EventEmitter, Injectable, Output, Directive } from "@angular/core";
import {Observable} from "rxjs";
import {environment} from "../../../environments/environment";
import {InstitutionUnit} from "../../models/Institution-unit";
import {Registration} from "../../models/registration";
import {RegistrationInstitution} from "../../models/registration-institution";
import {RegistrationUnit} from "../../models/registration-unit";
import {Role} from "../../models/role";
import {RoleInstitution} from "../../models/role-institution";

@Directive()
@Injectable()
export class UnitService {

  public institutionUnit: InstitutionUnit;
  public institutionUnits: InstitutionUnit[];

  public registration: Registration;
  public registrationInstitutions: RegistrationInstitution[];
  public registrationUnits: RegistrationUnit[];

  public role: Role;
  public roleInstitutions: RoleInstitution[];
  public roleInstitution: RoleInstitution;
  public roleUnits: RoleInstitution[];

  public addNew: boolean;
  public context: string;

  @Output() public editData: EventEmitter<any> = new EventEmitter();
  @Output() public update: EventEmitter<any> = new EventEmitter();

  public initEdit() {
    this.editData.emit({
      institutionUnit: this.institutionUnit,
      registration: this.registration,
      registrationInstitutions: this.registrationInstitutions,
      registrationUnits: this.registrationUnits,
      role: this.role,
      roleInstitutions: this.roleInstitutions,
      roleInstitution: this.roleInstitution,
      roleUnits: this.roleUnits,
      addNew: this.addNew,
      context: this.context,
    });
  }

  public resetData() {
    this.institutionUnit = null;
    this.institutionUnits = null;

    this.registration = null;
    this.registrationInstitutions = null;
    this.registrationUnits = null;

    this.role = null;
    this.roleInstitutions = null;
    this.roleInstitution = null;
    this.roleUnits = null;

    this.addNew = null;
    this.context = "";
  }

  public updateData() {
    this.update.emit({
      update: true,
    });
  }

}
